"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dropoffAnalyticsCSS = exports.commentsButton = exports.choiceAnswer = exports.dialogue = void 0;
const fixWebpackAndRemoveMe_1 = require("../../../img/fixWebpackAndRemoveMe");
exports.dialogue = `
    :host {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
    }
    
    * {
        font-family: Eponymous;
        font-weight: 400;
    }
    
    .dialogue {
        background-color: rgba(0, 0, 0, 0.85);
        padding: calc(8 * var(--dor-vw)) calc(4 * var(--dor-vw)) calc(4 * var(--dor-vw)) calc(4 * var(--dor-vw));
        position: relative;
    }
    :host(.is-multiplayer) .dialogue {
        padding-bottom: calc(30 * var(--dor-vw));
    }
    :host(.invisible-text) .dialogue-body > span {
        opacity: 0;
    }
    .dialogue-heading {
        background: url(${fixWebpackAndRemoveMe_1.dialogueHeading}) no-repeat 0 50%;
        background-size: contain;
        position: absolute;
        left: 0;
        top: calc(-5 * var(--dor-vw));
        height: calc(10 * var(--dor-vw));
        width: calc(100 * var(--dor-vw));
        color: #000;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        padding: calc(3 * var(--dor-vw));
        font-size: calc(5 * var(--dor-vw));
        box-sizing: border-box;
    }
    .dialogue-body {
        color: #fff;
        font-size: calc(4.5 * var(--dor-vw));
        white-space: break-spaces;
        min-height: calc(16 * var(--dor-vw));
        width: 100%;
    }
    
    :host(.type-narrator) .dialogue-heading,
    :host(.type-text) .dialogue-heading,
    :host(.type-ending) .dialogue-heading {
        color: transparent;
        font-size: 0;
    }
    
    :host(.type-choice) {
        display: none;
    }
`;
exports.choiceAnswer = `
    :host {
        --button-background-color: rgba(0, 0, 0, 0.9);
        --button-background-color-special: rgba(255, 255, 255, 0.9);
        --screen-margin: calc(3 * var(--dor-vw));
        position: absolute;
        top: calc((34 * var(--dor-vh)) - env(safe-area-inset-bottom, 0px) + (var(--button-num) * (17 * var(--dor-vw)) - (7 * var(--dor-vw))));
        pointer-events: all;
        width: 100%;
    }
    :host(.inactive) {
        pointer-events: none;
    }
    :host(.invisible-text) .choice-text-inside {
        opacity: 0;
    }
    * {
        margin: 0;
        padding: 0;
        box-sizing: border-box;
        font-family: Eponymous;
        font-weight: 400;
    }
    .choice-container {
        box-sizing: border-box;
        width: 100%;
        height: calc(15 * var(--dor-vw));
        opacity: 1;
        padding: 0;
        margin: 0;
        display: flex;
    }

    .choice-icon {
        display: none;
    }

    .choice-border {
        box-sizing: border-box;
        width: 100%;
        height: 100%;
        margin: 0;
        padding: 0;
        border: 0;
        background: linear-gradient(90deg, rgba(0,0,0,0) 0, var(--button-background-color) 20%, var(--button-background-color) 80%, rgba(0,0,0,0) 100%) transparent;
        color: #FFF;
    }
    :host(.type-erotic) .choice-border,
    :host(.type-paid) .choice-border {
        background: linear-gradient(90deg, rgba(255,255,255,0) 0, var(--button-background-color-special) 20%, var(--button-background-color-special) 80%, rgba(255,255,255,0) 100%) transparent;
        color: #000;
    }
    .choice-btn {
        display: flex;
        justify-content: center;
        align-items:center;
        gap: calc(5 * var(--dor-vw));
        width: 100%;
        height: 100%;
        overflow: hidden;
        border: 0;
    }
    :host(.unselected) .choice-btn {
        opacity: .5;
    }

    .choice-text,
    .choice-text-inside {
        text-align: center;
    }

    .choice-text {
        width: 50%;
        font-size: calc(4 * var(--dor-vw));
        white-space: break-spaces;
    }
    .choice-cost {
        max-width: 20%;
    }
    :host(.type-paid) .choice-cost,
    :host(.type-romantic) .choice-cost,
    :host(.type-erotic) .choice-cost {
        display: block;
    }
    :host(.is-multiplayer) .choice-cost {
        display: none !important;
    }

    .choice-cost-icon {
        width: calc(8 * var(--dor-vw));
        height: calc(8 * var(--dor-vw));
    }
    
    .choice-cost-icon.key-type {
        width: 100%; 
        margin: auto;
    }
    .choice-cost-icon.is-author {
        filter: grayscale(100%)
    }
    :host(.cost-heart) .choice-cost-icon {
        background: url(${fixWebpackAndRemoveMe_1.choiceCostIconHeart}) no-repeat 50% 50%;
        background-size: calc(8 * var(--dor-vw));
    }
    
    .choice-cost-inside {
        display: none;
        flex-direction: row;
        align-items: center;
        font-size: calc(5 * var(--dor-vw));
        justify-content: space-between;
        height: 100%;
        padding: calc(2 * var(--dor-vw)) calc(1 * var(--dor-vw));
    }
    :host(.cost-heart) .choice-cost-inside {
        display: flex;
    }
    
    .choice-multiplayer-ui {
        display: none;
        position: absolute;
        height: calc(7.5 * var(--dor-vw));
        right: calc(0.5 * var(--dor-vw));
        top: calc(-3.5 * var(--dor-vw));
        flex-direction: row;
        align-items: center;
        font-size: calc(4.5 * var(--dor-vw));
    }
    
    :host(.is-multiplayer) .choice-multiplayer-ui {
        display: flex;
    }

    .choice-avatar {
        height: 100%;
        margin-right: calc(0.75 * var(--dor-vw));
        background: white;
        border-radius: 200px;
    }

    .choice-votes-counter {
        font-size: calc(3 * var(--dor-vw));
        font-weight: bold;
        text-align: center;
        color: #f7a397;
        border-radius: calc(3.75 * var(--dor-vw));
        background-color: #2C2C2C;
        min-width: calc(5.5 * var(--dor-vw));
        height: calc(5.5 * var(--dor-vw));
        line-height: calc(5.5 * var(--dor-vw));
        padding: 0 calc(2 * var(--dor-vw));
    }
    .choice-votes-counter.one-digit {
        width: calc(5.5 * var(--dor-vw));
        padding: 0;
    }
    
    .choice-winning-checkmark {
        position: absolute;
        right: calc(3.5 * var(--dor-vw));
        top: calc(6 * var(--dor-vw));
        width: calc(5 * var(--dor-vw));
        height: calc(5 * var(--dor-vw));
        display: none;
    }
    :host(.is-multiplayer.winning-check-mark-visible) .choice-winning-checkmark {
        display: block;
    }
    .choice-winning-checkmark > img {
        width: 100%;
        height: 100%;
    }

    .choice-debug {
        position: absolute;
        top: 2%;
        left: 2%;
        color: white;
    }
    :host(.is-disabled) {
        opacity: 0.5;
    }
    :host(.is-hidden) {
        visibility: hidden;
    }
    :host(.is-choice-memory-debug.is-disabled) {
        visibility: visible;
        opacity: 0.6;
        border: 1px solid orange;
    }
    :host(.is-choice-memory-debug.is-hidden) {
        visibility: visible;
        opacity: 0.6;
        border: 1px solid red;
    }

    :host(.is-choice-memory-debug.is-disabled) .choice-debug {
        color: orange;
    }

    :host(.is-choice-memory-debug.is-hidden) .choice-debug {
        color: red;
    }


    :host .choice-analytics {
        display: none;
        width: 20%;
        margin: calc(0.75 * var(--dor-vw)) var(--screen-margin);

        position: absolute;
        right: 0;
        top: 0;
        box-sizing: border-box;
    }

    :host(.is-analytics) .choice-analytics {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 90%;
    }

    :host(.is-analytics) .choice-border {
        width: 73%;
    }
    
    :host(.is-analytics) .choice-analytics .analytics-box-wrapper {
        display: flex;
        flex-direction: column;
        justify-content: space-evenly;
        width: 100%;
        height: 100%;
    }
    :host(.is-analytics) .choice-analytics .analytics-box {
        background-color: rgb(44, 44, 44);
        box-shadow: rgba(52, 58, 64, 0.54) 0px 2px 5px 0px, rgba(52, 58, 64, 0.54) -1px 4px 13px -4px inset;
        color: rgb(255, 255, 255);
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        align-items: center;
        gap: var(--dor-vw);
        padding: calc(0.5 * var(--dor-vw));
        font-size: calc(3 * var(--dor-vw));
        font-weight: 700;
        width: 100%;
        height: 100%;
        text-align: right;
        
        border-width: 1px;
        border-style: solid;
        border-color: rgb(173, 181, 189);
        border-image: initial;
        border-radius: calc(2 * var(--dor-vw));
    }
`;
exports.commentsButton = `
    :host {
        position: absolute;
        top: calc((25 * var(--dor-vh)) - env(safe-area-inset-bottom, 0px) - (10 * var(--dor-vw)));
        left: calc(50 * var(--dor-vw));
        pointer-events: all;
        transform: translate(-50%, 0);
    }
    
    * {
        font-family: Eponymous;
    }

    :host(.is-multiplayer), 
    :host(.is-hidden) {
        display: none;
    }
    .comments-button {
        display: flex;
        justify-content: space-between;
        align-items: center;
        min-width: calc(2 * var(--dor-vw));
        padding: calc(2 * var(--dor-vw)) calc(2 * var(--dor-vw));
        font-weight: normal;
        border-radius: calc(2 * var(--dor-vw));
    }
    .comments-icon {
        display: inline-block;
        width: calc(10 * var(--dor-vw));
        height: calc(10 * var(--dor-vw));
        background: url(${fixWebpackAndRemoveMe_1.arcanaCommentIcon}) no-repeat 50% 50%;
        background-size: contain;
    }
    .comments-counter {
        color: #fff;
        font-size: calc(4.25 * var(--dor-vw));
    }
`;
exports.dropoffAnalyticsCSS = `
    :host {
        position: aboslute;
        top: 0;
        left: 0;
    }
    :host .dropoff {
        background-color: rgb(251, 176, 52);
        background-image: linear-gradient(315deg, rgb(251, 176, 52), rgb(255, 221, 0) 74%);
        box-shadow: rgba(44, 44, 44, 0.54) 0px 2px 5px 0px, rgba(44, 44, 44, 0.54) -1px 4px 13px -4px inset;
        color: rgb(44, 44, 44);
        font-weight: 600;
        
        width: calc(21 * var(--dor-vw));
        height: calc(21 * var(--dor-vw));

        top: calc(5 * var(--dor-vw));
        left: 50%;
        transform: translate(-50%);

        opacity: 1;
        position: absolute;
        text-align: center;
        
        border-width: 2px;
        border-style: solid;
        border-color: rgb(255, 255, 255);
        border-image: initial;
        border-radius: 50%;
    }

    :host .dropoff .dropofftext {
        font-size: 1.2em;
        font-size: calc(3 * var(--dor-vw));
        font-weight: 800;
        line-height: 1;
        padding: calc(2.5 * var(--dor-vw)) 0px 0px;
    }

    :host .dropoff .dropoffvalue {
        font-size: calc(8 * var(--dor-vw));
        line-height: calc(8 * var(--dor-vw));
    }

    :host .dropoff .dropoffsubtext {
        white-space: nowrap;
        display: flex;
        justify-content: center;
        align-items: baseline;
    }

    :host(.is-counts) .dropoffpercent {
        display: none;
    }
    :host(.is-percentage) .dropoffpercent {
        display: block;
    }
    :host(.is-hide) {
        display: none;
    }
`;
